import IconEmptyState from "./solicitacoes.svg"
import FaturaIcon from "./fatura.svg"
import iconError from "./erro-desbloqueio.svg"
import IconArrow from "./seta_baixo.svg"
import EmptyStatePIX from "./empty_state_pix.svg"

export { IconEmptyState, FaturaIcon, iconError, IconArrow, EmptyStatePIX }



// WEBPACK FOOTER //
// ./src/assets/svg/index.js